<template>
  <div class="interiorzone">
    <h2 class="subheading">打款认证——待打款</h2>
    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-payorder-list">
          <li class="hd">
            <span>序号</span>
            <span>公司名称</span>
            <span>开户行</span>
            <span>账户号</span>
            <span>拟分配贴现行</span>
            <span>是否已打款</span>
          </li>
          <li  v-for="(item,index) in companylist" v-bind:key="index">
            <span>{{index + 1}}</span>
            <span>{{item.companyName}}</span>
            <span>{{item.bankAccontName}}</span>
            <span>{{item.bankAccontCode}}</span>
            <span>{{item.planBank}}</span>
            <span class="infoperation"><div class="ysbox"><i @click="openpanel(1,item.orderId)">已打款</i> <i @click="openpanel(2,item.orderId)">打款失败</i></div></span>
          </li>
        </ul>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(total)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>
    <div class='adopt' v-if="adoptpanel">
    <h2>请确认合作银行已向其对公账户打款？</h2>
    <div class="btn-confirm"><button class="addok" @click="orderadopt()">确认</button> <button class="addok" @click="colosepanel(1)">取消</button></div>
    </div>
    <div class="rejectbox" v-if="rejectboxpanel">
      <h2>请填写打款失败原因：</h2>
      <textarea v-model="whatfail"></textarea>
      <div class="btn-confirm"><button class="addok"  @click="orderreject()">确认</button> <button class="addno" @click="colosepanel(2)">取消</button></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pagenum:0,
      currentPage:1,
      pageSize:10,
      companyName:'',
      companylist:[],
      ifpageshow:false,
      adoptpanel:'',
      rejectboxpanel:'',
      whatfail:''
    }
  },
  mounted:function() {
    this.readlist();
  },
  methods: {
    readlist(){
      this.ajax.post('/auth/piaoOrderList',{bizContent:{currentPage:this.currentPage,pageSize:this.pageSize,orderType:'5',orderSubType:'2',status:'100'}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.pagenum=result.data.data.pages
            this.pagenum>1?this.ifpageshow=true:this.ifpageshow=false
            this.companylist=result.data.data.data
          }
        }
      )
    },
    nextpage(item){
      this.currentPage=item
      this. readlist()
    },
    lookdetails(val){
      console.log(this.companylist[val]);
       this.$router.push({name:'OrganDetails', params: { companyinfo:this.companylist[val]}})
    },
    openpanel(key,val){
      this.orderid=val
      if(key==1){
        this.adoptpanel=true
      }
      else if(key==2){
        this.rejectboxpanel=true
      }
    },
    orderadopt(){
      this.ajax.post('/auth/piaoOrderInspect',{bizContent:{orderId:this.orderid}} )
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.companylist=new Array()
            this.readlist()
            this.adoptpanel=false
          }
        }
      )
    },
    orderreject(){
      this.ajax.post('/auth/piaoOrderReject',{bizContent:{orderId:this.orderid,desc:this.whatfail}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.companylist=new Array()
            this.rejectboxpanel=false
            this.readlist()
            this.whatfail=''
          }
        }
      )
    },
    colosepanel(val){
      if(val==1){
        this.adoptpanel=false
      }
      else if(val==2){
        this.rejectboxpanel=false
      }
      this.whatfail=''
    }
  }
}
</script>

<style scoped>
.adopt{
  position:absolute;
  left:50%;
  margin-left:-137px;
  top:50%;
  margin-top:-59px;
  width:274px;
  height:118px;
  background:rgba(255,255,255,1);
  border:1px solid rgba(14,133,238,1);
  box-shadow:0px 28px 76px rgba(0,0,0,0.17);
  border-radius:5px;
}
.adopt h2{
  width:84%;
  margin:0 8%;
  margin-top:15px;
  text-align: center;
  font-size:16px;
}
.adopt .btnbox{
  display:table;
  margin:0 auto;
}
.rejectbox{
  position: absolute;
  left: 50%;
  top:50%;
  margin-left:-322px;
  margin-top:-167px;
  width:645px;
  height:334px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 10px rgba(204,204,204,1);
  border-radius:2px;
}
.rejectbox h2,.rejectbox textarea{
  width:581px;
  margin:0 auto;
  display: block;
}
.rejectbox h2{
  font-size: 16px;
  color:#222222;
  margin-top:32px;
}
.rejectbox textarea{
  margin-top:20px;
   width:561px;
  padding:5px 10px;
  height:150px;
  border:1px solid rgba(227,228,229,1);
  margin-bottom: 10px;
}
.rejectbox .btn-confirm button{
  width:240px;
  height:52px;
  line-height:52px;
  border-radius: 2px;
  cursor: pointer;
}
.rejectbox .addno{
  border:1px solid rgba(61,143,226,1);
  box-shadow:0px 2px 7px rgba(61,143,226,0.5);
  margin-left:20px;
}
.redio:hover{
  text-decoration: underline;
  color:rgba(61,143,226,1);
}
</style>


// WEBPACK FOOTER //
// src/page/bankacceptance/payauth.vue